<template>
  <div
    class="tags-selector">
    <span
      class="margin-right-m">
      {{ $t('explorer.selectMultiplePairs') }}
    </span>
    <treeselect
      class="select-width"
      :multiple="true"
      v-on:input="onInput"
      :value="value"
      placeholder=""
      noOptionsText=""
      :options="options"
      :valueConsistsOf="'LEAF_PRIORITY'">
    </treeselect>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';

export default {
  name: 'TagsSelector',
  components: {
    Treeselect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    maxValues: {
      type: Number,
      default: -1
    }
  },
  methods: {
    onInput (ids) {
      if (this.maxValues !== -1 && this.maxValues < ids.length) {
        ids.shift();
      }

      this.$emit('input', ids);
    }
  }
};

</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .select-width {
    width: 32rem;
  }

  .tags-selector {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/multiple/TagsSelector.vue